import { mapValues, uniq } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { getBundlesByTruckloadGuid, getStatusesByBundleGuid } from './bundles';

export const getStatusesByTruckloadGuid = createSelector(
  (state: RootState) => state.truckloads,
  getBundlesByTruckloadGuid,
  getStatusesByBundleGuid,

  (truckloads, bundlesByTruckloadGuid, statusesByBundleGuid) =>
    mapValues(truckloads, (truckload) =>
      uniq(bundlesByTruckloadGuid[truckload.guid]?.flatMap((bundle) => statusesByBundleGuid[bundle.guid])),
    ),
);
